import { Alert, Button, Spinner } from 'reactstrap';

/**
 * Microsoft connection state, driven by the saved Entra app (oauthEntraConfigured)
 * and the connected mailbox (oauthConnected).
 */
const ConnectionStatus = ({
    t,
    oauthEntraConfigured,
    oauthConnected,
    mailboxAccountEmail,
    isConnecting,
    isDisconnecting,
    onConnectClick,
    onReconnectClick,
    onDisconnectClick,
}) => {
    const isBusy = isConnecting || isDisconnecting;

    if (oauthConnected) {
        return (
            <Alert color="success" className="d-flex justify-content-between align-items-center flex-wrap mb-0">
                <div className="d-flex align-items-center me-3">
                    <i className="ri-checkbox-circle-line font-size-22 me-2" />
                    <div>
                        <div className="fw-semibold">
                            {t('Microsoft connected')}
                        </div>
                        {mailboxAccountEmail && (
                            <div className="font-size-12">
                                {mailboxAccountEmail}
                            </div>
                        )}
                    </div>
                </div>
                <div className="d-flex align-items-center gap-2">
                    <Button
                        type="button"
                        color="secondary"
                        outline
                        disabled={isBusy || !oauthEntraConfigured}
                        onClick={onReconnectClick}
                    >
                        {isConnecting && (
                            <Spinner size="sm" className="me-2" />
                        )}
                        {t('Reconnect')}
                    </Button>
                    <Button
                        type="button"
                        color="danger"
                        outline
                        disabled={isBusy}
                        onClick={onDisconnectClick}
                    >
                        {isDisconnecting && (
                            <Spinner size="sm" color="danger" className="me-2" />
                        )}
                        {t('Disconnect')}
                    </Button>
                </div>
            </Alert>
        );
    }

    if (oauthEntraConfigured) {
        return (
            <Alert color="warning" className="mb-0">
                <div className="d-flex align-items-start mb-3">
                    <i className="ri-error-warning-line font-size-22 me-2" />
                    <div>
                        <div className="fw-semibold">
                            {t('Microsoft not connected')}
                        </div>
                        <div className="font-size-13">
                            {t('Entra app saved. Click Connect Microsoft and sign in as this mailbox.')}
                        </div>
                    </div>
                </div>
                <Button
                    type="button"
                    color="primary"
                    disabled={isBusy}
                    onClick={onConnectClick}
                >
                    {isConnecting && (
                        <Spinner size="sm" className="me-2" />
                    )}
                    {t('Connect Microsoft')}
                </Button>
            </Alert>
        );
    }

    return (
        <Alert color="light" className="border mb-0">
            <div className="fw-semibold">
                {t('Microsoft not connected')}
            </div>
            <div className="text-muted font-size-13 mb-3">
                {t('Save Tenant ID, Client ID and Client secret, then connect.')}
            </div>
            <Button
                type="button"
                color="primary"
                disabled
            >
                {t('Connect Microsoft')}
            </Button>
        </Alert>
    );
};

export default ConnectionStatus;
